import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from "react-router-dom";
import moment from "moment/moment";
import ErrorModal from "../../../Components/ErrorModal/ErrorModal";
import ReactTable from "react-table";

const CileContentEpubList = (props) => {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [pagina, setPagina] = useState(0);
    const [limite, setLimite] = useState(10);
    const [isLoadingProdutos, setIsLoadingProdutos] = useState(true);

    const chamadaLivros = () => {
        const config = new Configurations();
        setIsLoadingProdutos(true);
        setLoading(true);
        let url = config.apiBasePath + `/conteudo-cile/epub/lista-hml?limite=${limite}&pagina=${pagina + 1}`;
        axios.get(url)
            .then(response => {
                setData(response.data)
                setIsLoadingProdutos(false)
                setTotalPaginas(response.data.paginacao.totalPaginas)
            })
            .catch(error => {
                setErrorMessage(error.response.data.message || "Ocorreu um erro ao buscar os livros.");
                toggleErrorModal();
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const getStatusBadge = (value) => {
        switch (value) {
            case 0:
                return { className: 'secondary', text: 'Não iniciado' };
            case 1:
                return { className: 'secondary', text: 'Em homologação' };
            case 2:
                return { className: 'primary badge-opacity', text: 'Homologado' };
            case 3:
                return { className: 'success badge-opacity', text: 'Em produção' };
            default:
                return { className: 'warning badge-opacity', text: 'Não iniciado' };
        }
    };

    const columns = [
        {
            Header: 'id',
            accessor: 'id',
            className: 'text-center pointer',
            width: 50
        },
        {
            Header: 'Título',
            accessor: 'title',
            className: 'text-center pointer',
            width: 500
        },
        {
            Header: 'Data de criação',
            accessor: 'created_at',
            className: 'text-center pointer',
            width: 140,
            Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>-</span>)
        },
        {
            Header: 'Status',
            className: 'text-center pointer',
            accessor: 'approval_status',
            Cell: row => {
                const { className, text } = getStatusBadge(row.value);
                return (
                    <h6 className="m-0">
                        <span className={`badge badge-${className}`}>
                            {text}
                        </span>
                    </h6>
                );
            },
            width: 160,
        },
    ];

    const onPageChange = pageIndex => {
        setPagina(pageIndex);
    };

    const onPageSizeChange = (pageSize, pageIndex) => {
        setLimite(pageSize);
        setPagina(pageIndex);
    };

    const toggleErrorModal = () => {
        setOpenErrorModal(!openErrorModal);
    }

    useEffect(() => {
        chamadaLivros();
    }, [pagina, limite]);


    return (
        <>
            <div className="cile-remessas">
                <div className="row">
                    <div className="col-12 py-2">
                        <div className="row no-gutters align-items-center">
                            <div className="col-12 col-lg-4 text-center text-lg-left">
                                <h2 className="title-1 d-none d-lg-block">CILE - EPUBs </h2>
                            </div>
                            <div className="col-12 col-lg-4 text-center text-lg-center">
                                <div className="row no-gutters">
                                    <div className="col py-2 py-lg-0">
                                        <button onClick={() => props.history.push('/cile/conteudo/epub/detalhes/novo')} className="btn btn-outline-info">Novo Livro</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 text-center text-lg-right">
                                <div className="row no-gutters">
                                    <div className="col py-2 py-lg-0">
                                        <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="row no-gutters d-flex justify-content-center align-items-center py-lg-4">

                        {loading ?
                            <div className="d-flex justify-content-center w-100">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                            :
                            <>
                                <ReactTable
                                    data={data.livros}
                                    columns={columns}
                                    manual
                                    pages={totalPaginas}
                                    page={pagina}
                                    pageSize={limite}
                                    onPageChange={onPageChange}
                                    onPageSizeChange={onPageSizeChange}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum produto encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    loading={isLoadingProdutos}
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: () => {
                                                props.history.push({
                                                    pathname: `/cile/conteudo/epub/detalhes/geracao/${rowInfo.original.id}`,
                                                })
                                            }
                                        }
                                    }}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
            <ErrorModal
                isOpen={openErrorModal}
                message={errorMessage}
                closeErrorModal={() => { toggleErrorModal(); }}
            />
        </>
    )
}


export default withRouter(CileContentEpubList);